/** Shared authenticated client for Archive Command endpoints. */
import axios from "axios";
import { API } from "../lib/api";

export const authHeaders = () => {
  const h = {};
  try {
    const op = sessionStorage.getItem("archive-admin-token");
    if (op) h["x-admin-token"] = op;
    const sess = localStorage.getItem("archive_member_token");
    if (sess) h.Authorization = `Bearer ${sess}`;
  } catch { /* no-op */ }
  return h;
};

export const api = (path, opts = {}) =>
  axios({ url: `${API}${path}`, headers: authHeaders(), ...opts }).then((r) => r.data);

export const track = (kind, item, workspace) =>
  api("/command/track", { method: "post", data: { kind, item, workspace } }).catch(() => {});
